const country = {
  ABW: '阿爾巴',
  AFG: '阿富汗',
  AGO: '安哥拉',
  AIA: '安圭拉',
  ALA: '奧蘭群島',
  ALB: '阿爾巴尼亞',
  AND: '安道爾',
  ARE: '阿拉伯聯合大公國',
  ARG: '阿根廷',
  ARM: '亞美尼亞',
  ASM: '美屬薩摩亞',
  ATA: '南極',
  ATF: '法屬南部領地及南極地區',
  ATG: '安地卡及巴布達',
  AUS: '澳洲',
  AUT: '奧地利',
  AZE: '亞塞拜然',
  BDI: '蒲隆地',
  BEL: '比利時',
  BEN: '貝南',
  BES: '博內爾島、聖尤斯特歇斯島和薩巴島',
  BFA: '布吉納法索',
  BGD: '孟加拉',
  BGR: '保加利亞',
  BHR: '巴林',
  BHS: '巴哈馬',
  BIH: '波士尼亞與赫塞哥維納',
  BLM: '聖巴泰勒米',
  BLR: '白俄羅斯',
  BLZ: '貝里斯',
  BMU: '百慕達',
  BOL: '玻利維亞多民族國',
  BRA: '巴西',
  BRB: '巴貝多',
  BRN: '汶萊達魯薩蘭國',
  BTN: '不丹',
  BVT: '布韋島',
  BWA: '波札那',
  CAF: '中非共和國',
  CAN: '加拿大',
  CCK: '科科斯（基林）群島',
  CHE: '瑞士',
  CHL: '智利',
  CHN: '中華人民共和國',
  CIV: '科特迪瓦',
  CMR: '喀麥隆',
  COD: '剛果民主共和國',
  COG: '剛果共和國',
  COK: '庫克群島',
  COL: '哥倫比亞',
  COM: '葛摩',
  CPV: '維德角',
  CRI: '哥斯大黎加',
  CUB: '古巴',
  CUW: '庫拉索',
  CXR: '聖誕島',
  CYM: '開曼群島',
  CYP: '賽普勒斯',
  CZE: '捷克共和國',
  DEU: '德國',
  DJI: '吉布地',
  DMA: '多明尼克',
  DNK: '丹麥',
  DOM: '多明尼加共和國',
  DZA: '阿爾及利亞',
  ECU: '厄瓜多',
  EGY: '埃及',
  ERI: '厄利垂亞',
  ESH: '西撒哈拉',
  ESP: '西班牙',
  EST: '愛沙尼亞',
  ETH: '衣索比亞',
  FIN: '芬蘭',
  FJI: '斐濟',
  FLK: '福克蘭群島（馬爾維納斯群島）',
  FRA: '法國',
  FRO: '法羅群島',
  FSM: '密克羅尼西亞聯邦',
  GAB: '加彭',
  GBR: '英國',
  GEO: '喬治亞',
  GGY: '格恩西島',
  GHA: '迦納',
  GIB: '直布羅陀',
  GIN: '幾內亞',
  GLP: '瓜德魯普',
  GMB: '甘比亞',
  GNB: '幾內亞比紹',
  GNQ: '赤道幾內亞',
  GRC: '希臘',
  GRD: '格瑞那達',
  GRL: '格陵蘭',
  GTM: '瓜地馬拉',
  GUF: '法屬圭亞那',
  GUM: '關島',
  GUY: '蓋亞那',
  HKG: '香港',
  HMD: '赫德島和麥克唐納群島',
  HND: '宏都拉斯',
  HRV: '克羅埃西亞',
  HTI: '海地',
  HUN: '匈牙利',
  IDN: '印尼',
  IMN: '馬恩島',
  IND: '印度',
  IOT: '英屬印度洋領地',
  IRL: '愛爾蘭',
  IRN: '伊朗伊斯蘭共和國',
  IRQ: '伊拉克',
  ISL: '冰島',
  ISR: '以色列',
  ITA: '義大利',
  JAM: '牙買加',
  JEY: '澤西島',
  JOR: '約旦',
  JPN: '日本',
  KAZ: '哈薩克',
  KEN: '肯亞',
  KGZ: '吉爾吉斯斯坦',
  KHM: '柬埔寨',
  KIR: '吉里巴斯',
  KNA: '聖克里斯多福及尼維斯',
  KOR: '大韓民國',
  KWT: '科威特',
  LAO: '寮國人民民主共和國',
  LBN: '黎巴嫩',
  LBR: '賴比瑞亞',
  LBY: '利比亞',
  LCA: '聖露西亞',
  LIE: '列支敦斯登',
  LKA: '斯里蘭卡',
  LSO: '賴索托',
  LTU: '立陶宛',
  LUX: '盧森堡',
  LVA: '拉脫維亞',
  MAC: '澳門',
  MAF: '聖馬丁（法國領土）',
  MAR: '摩洛哥',
  MCO: '摩納哥',
  MDA: '摩爾多瓦共和國',
  MDG: '馬達加斯加',
  MDV: '馬爾地夫',
  MEX: '墨西哥',
  MHL: '馬紹爾群島',
  MKD: '北馬其頓',
  MLI: '馬利',
  MLT: '馬爾他',
  MMR: '緬甸',
  MNE: '蒙特內哥羅',
  MNG: '蒙古',
  MNP: '北馬裡亞納群島',
  MOZ: '莫三比克',
  MRT: '茅利塔尼亞',
  MSR: '蒙特塞拉特',
  MTQ: '馬提尼克島',
  MUS: '模里西斯',
  MWI: '馬拉威',
  MYS: '馬來西亞',
  MYT: '馬約特島',
  NAM: '納米比亞',
  NCL: '新喀裡多尼亞',
  NER: '尼日',
  NFK: '諾福克島',
  NGA: '奈及利亞',
  NIC: '尼加拉瓜',
  NIU: '紐埃',
  NLD: '荷蘭',
  NOR: '挪威',
  NPL: '尼泊爾',
  NRU: '諾魯',
  NZL: '紐西蘭',
  OMN: '阿曼',
  PAK: '巴基斯坦',
  PAN: '巴拿馬',
  PCN: '皮特凱恩',
  PER: '秘魯',
  PHL: '菲律賓',
  PLW: '帛琉',
  PNG: '巴布亞紐幾內亞',
  POL: '波蘭',
  PRI: '波多黎各',
  PRK: '朝鮮民主主義人民共和國',
  PRT: '葡萄牙',
  PRY: '巴拉圭',
  PSE: '巴勒斯坦',
  PYF: '法屬玻里尼西亞',
  QAT: '卡達',
  REU: '留尼旺島',
  ROU: '羅馬尼亞',
  RUS: '俄羅斯聯邦',
  RWA: '盧安達',
  SAU: '沙烏地阿拉伯',
  SDN: '蘇丹',
  SEN: '塞內加爾',
  SGP: '新加坡',
  SGS: '南喬治亞島和南桑威奇群島',
  SHN: '聖赫勒拿島、阿森松島和特里斯坦-達庫尼亞群島',
  SJM: '斯瓦爾巴群島和揚馬延島',
  SLB: '索羅門群島',
  SLE: '獅子山',
  SLV: '薩爾瓦多',
  SMR: '聖馬利諾',
  SOM: '索馬利亞',
  SPM: '聖皮埃爾島和密克隆島',
  SRB: '塞爾維亞',
  SSD: '南蘇丹',
  STP: '聖多美和普林西比',
  SUR: '蘇利南',
  SVK: '斯洛伐克',
  SVN: '斯洛維尼亞',
  SWE: '瑞典',
  SWZ: '史瓦濟蘭',
  SXM: '聖馬丁島（荷蘭領土）',
  SYC: '塞席爾',
  SYR: '阿拉伯敘利亞共和國',
  TCA: '特克斯和凱科斯群島',
  TCD: '查德',
  TGO: '多哥',
  THA: '泰國',
  TJK: '塔吉克',
  TKL: '托克勞',
  TKM: '土庫曼',
  TLS: '東帝汶',
  TON: '東加',
  TTO: '千里達及托巴哥',
  TUN: '突尼西亞',
  TUR: '土耳其',
  TUV: '吐瓦魯',
  TWN: '台灣',
  TZA: '坦尚尼亞',
  UGA: '烏幹達',
  UKR: '烏克蘭',
  UMI: '美國海外小島',
  URY: '烏拉圭',
  USA: '美國',
  UZB: '烏茲別克',
  VAT: '梵蒂岡城',
  VCT: '聖文森及格瑞那丁',
  VEN: '委內瑞拉玻利瓦爾共和國',
  VGB: '英屬維京群島',
  VIR: '美屬維京群島',
  VNM: '越南',
  VUT: '萬那杜',
  WLF: '瓦利斯富圖納群島',
  WSM: '薩摩亞',
  YEM: '葉門',
  ZAF: '南非',
  ZMB: '尚比亞',
  ZWE: '辛巴威',
  UNDEFINED: ''
};
export default country;
